import {
  Button, Typography,
} from '@mui/material';
import styled, { keyframes } from 'styled-components';

import { AnimateType } from './types';

export const ANIMATION_TIME_SEC = 0.2;

const RootContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

interface ColumnContainerProps {
  animate: AnimateType,
}

const calendarSlideRight = keyframes`
from  {
  opacity: 0%;
  transform: translateX(15%);
}
to  {
  transform: translateX(0%);
  opacity: 100%;
}
`;

const calendarSlideLeft = keyframes`
from  {
  opacity: 0%;
  transform: translateX(-15%);
}
to  {
  transform: translateX(0%);
  opacity: 100%;
}
`;

const calendarShake = keyframes`
0% { 
  transform: translateX(0%) 
}
25% { 
  transform: translateX(0.5%) 
}
50% { 
  transform: translateX(-0.5%)
}
75% { 
  transform: translateX(0.5%) 
}
100% { 
  transform: translateX(0%) 
  }
`;

const CalendarContainer = styled.div<ColumnContainerProps>`
  animation-duration: ${ANIMATION_TIME_SEC}s;
  animation-name: ${({ animate }) => {
    if (animate === AnimateType.Right) {
      return calendarSlideRight;
    } if (animate === AnimateType.Left) {
      return calendarSlideLeft;
    } if (animate === AnimateType.Shake) {
      return calendarShake;
    }
    return '';
  }};
  animation-timing-function: ease-out; 
`;

interface CalendarEntryContainerProps {
  $isToday: boolean,
  $columnCount: number,
}

const CalendarEntryContainer = styled.div<CalendarEntryContainerProps>`
  width: ${({ $columnCount }) => 100 / $columnCount}%;
  background-color: ${({ $isToday, theme }) => ($isToday ? theme.palette.backdrop.main : 'transparent')};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

const DateHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(1)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray.main};
`;

type TextProps = {
  $isToday: boolean,
}

const DateText = styled(Typography)<TextProps>`
  && {
    color: ${({ $isToday, theme }) => ($isToday ? theme.palette.darkPrimary.main : 'inherit')};
  }
`;

const Subtitle = styled(Typography)<TextProps>`
  && {
    font-weight: ${({ $isToday }) => ($isToday ? 600 : 500)};
    color: ${({ $isToday, theme }) => ($isToday ? theme.palette.darkPrimary.main : 'inherit')};
  }
`;

const NoDataContainer = styled(Typography)`
  && {
    text-align: center;
    margin-top: ${({ theme }) => theme.spacing(6)};
    margin-bottom: ${({ theme }) => theme.spacing(6)};
    user-select: none;
  }
`;

const CalendarToolbar = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(1, 2)};
`;

const TodayButton = styled(Button)`
  && {
    height: 36px;
    margin-left: ${({ theme }) => theme.spacing(1)};
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;

export { RootContainer,
  CalendarEntryContainer,
  CalendarContainer,
  DateHeader,
  DateText,
  CalendarToolbar,
  Subtitle,
  TodayButton,
  NoDataContainer };
